import { DOCUMENT } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Roulette } from 'app/public/model/roulette.model';
import { AppResolutionType } from 'app/shared/common/appResolution';
import { ResolutionType } from 'app/shared/model/enums';
import { MenuItem } from 'primeng/api';

@Component({
  selector: 'app-roulette-settings',
  templateUrl: './roulette-settings.component.html',
  styleUrls: ['./roulette-settings.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RouletteSettingsComponent implements OnInit {

  @Input()
  roulette: Roulette;
  @Input() form: NgForm;
  class:string
  displaySettings = AppResolutionType == ResolutionType.Desktop ? true : false;
  iconDirection =document.body.className === 'rtl'?'pi pi-chevron-right':'pi pi-chevron-left';

  constructor() { }
  ngOnInit(): void {
   this.class=document.body.className;
    
  }

  toggleSettings() {
    this.displaySettings = !this.displaySettings;
}

}
